import { render } from "./main-container-shell.vue?vue&type=template&id=582d770c&ts=true"
import script from "./main-container-shell.vue?vue&type=script&lang=ts"
export * from "./main-container-shell.vue?vue&type=script&lang=ts"

import "./main-container-shell.vue?vue&type=style&index=0&id=582d770c&lang=scss"

import exportComponent from "E:\\Build\\vsts-agent-win-x64-4.268.0\\_work\\1\\s\\Connect\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__